"use strict";

var _regeneratorRuntime = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Session = /*#__PURE__*/function () {
  function Session(api, device, state) {
    _classCallCheck(this, Session);

    this.api = api;
    this.device = device;
    this.state = state; //
  }

  _createClass(Session, [{
    key: "setup",
    value: function setup() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var token;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this.state.session;

                if (!_context.t0) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return this.verifyToken();

              case 4:
                _context.t0 = !_context.sent;

              case 5:
                if (!_context.t0) {
                  _context.next = 7;
                  break;
                }

                this.state.session$.next(null);

              case 7:
                if (this.state.session) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return this.createToken();

              case 10:
                token = _context.sent;
                this.state.session$.next({
                  token: token
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "reset",
    value: function reset() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          token = _ref.token;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _token;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.code = null;

                if (!(token && this.state.session)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 4;
                return this.destroyToken();

              case 4:
                this.state.session$.next(null);
                _context2.next = 7;
                return this.createToken();

              case 7:
                _token = _context2.sent;
                this.state.session$.next({
                  token: _token
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "createToken",
    value: function createToken() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var device, _yield$this$api$sendR, hash, signature, _yield$this$api$sendR2, token;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                device = this.state.deviceAddress; // create session code

                _context3.next = 3;
                return this.api.sendRequest({
                  method: 'POST',
                  path: 'session/hash',
                  body: {
                    device: device
                  }
                });

              case 3:
                _yield$this$api$sendR = _context3.sent;
                hash = _yield$this$api$sendR.hash;
                signature = this.device.signPersonalMessage(hash); // create session token

                _context3.next = 8;
                return this.api.sendRequest({
                  method: 'POST',
                  path: 'session',
                  body: {
                    device: device,
                    hash: hash,
                    signature: signature
                  }
                });

              case 8:
                _yield$this$api$sendR2 = _context3.sent;
                token = _yield$this$api$sendR2.token;
                return _context3.abrupt("return", token);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "verifyToken",
    value: function verifyToken() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                result = true;
                _context4.prev = 1;
                _context4.next = 4;
                return this.api.sendRequest({
                  method: 'GET',
                  path: 'session'
                });

              case 4:
                _context4.next = 9;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](1);
                result = false;

              case 9:
                return _context4.abrupt("return", result);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 6]]);
      }));
    }
  }, {
    key: "destroyToken",
    value: function destroyToken() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                result = true;
                _context5.prev = 1;
                _context5.next = 4;
                return this.api.sendRequest({
                  method: 'DELETE',
                  path: 'session'
                });

              case 4:
                _context5.next = 9;
                break;

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5["catch"](1);
                result = false;

              case 9:
                return _context5.abrupt("return", result);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[1, 6]]);
      }));
    }
  }, {
    key: "createCode",
    value: function createCode() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _yield$this$api$sendR3, code;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.api.sendRequest({
                  method: 'POST',
                  path: 'session/code'
                });

              case 2:
                _yield$this$api$sendR3 = _context6.sent;
                code = _yield$this$api$sendR3.code;
                this.code = code;
                return _context6.abrupt("return", code);

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "destroyCode",
    value: function destroyCode() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.api.sendRequest({
                  method: 'DELETE',
                  path: 'session/code'
                });

              case 2:
                this.code = null;

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "signCode",
    value: function signCode(creator, code) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var signature, _yield$this$api$sendR4, success;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                signature = this.device.signPersonalMessage(code);
                _context8.next = 3;
                return this.api.sendRequest({
                  method: 'PUT',
                  path: 'session/code',
                  body: {
                    creator: creator,
                    signature: signature
                  }
                });

              case 3:
                _yield$this$api$sendR4 = _context8.sent;
                success = _yield$this$api$sendR4.success;
                return _context8.abrupt("return", success);

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "verifyCode",
    value: function verifyCode(code) {
      var result = code && this.code && code === this.code;
      this.code = null;
      return result;
    }
  }]);

  return Session;
}();

exports.Session = Session;